import { useMeetingStore } from '../../host/stores';
import { effectFactory } from '../../utils/virtual-background';
import { ApiService } from '../services/api.service';
import { JitsiMeetingService } from '../services/jitsi-meeting.service';
import { JitsiWhisperService } from '../services/jitsi-whisper.service';

export let jitsiService: JitsiMeetingService | null = null;
export let jitsiWhisperService: JitsiWhisperService | null = null;

// NEX-817: Separate Jitsi instance for Webex screen sharing
export let webexJitsiService: JitsiMeetingService | null = null;

export function initializeJitsiMeetingService(): JitsiMeetingService {
  if (!jitsiService) {
    jitsiService = new JitsiMeetingService(
      {
        hosts: { domain: '8x8.vc', muc: 'conference.8x8.vc', anonymousdomain: '' },
        serviceUrl: 'wss://8x8.vc/xmpp-websocket',
        clientNode: 'http://jitsi.org/jitsimeet',
      },
      effectFactory
    );

    loadMeetingBackgroundImages();
  }

  return jitsiService;
}

// NEX-817: Separate initialization for Webex (screen sharing only)
export function initializeWebexJitsiMeetingService(): JitsiMeetingService {
  if (!webexJitsiService) {
    webexJitsiService = new JitsiMeetingService(
      {
        hosts: { domain: '8x8.vc', muc: 'conference.8x8.vc', anonymousdomain: '' },
        serviceUrl: 'wss://8x8.vc/xmpp-websocket',
        clientNode: 'http://jitsi.org/jitsimeet',
      },
      effectFactory
    );
  }

  return webexJitsiService;
}

export async function resetJitsiMeetingService(): Promise<void> {
  await jitsiService?.destroy();
  jitsiService = null;
}

// NEX-817: Reset Webex Jitsi instance
export async function resetWebexJitsiMeetingService(): Promise<void> {
  await webexJitsiService?.destroy();
  webexJitsiService = null;
}

const loadMeetingBackgroundImages = async () => {
  try {
    const response = await ApiService.request<any>({ endpoint: `/background-images` });
    useMeetingStore.getState().setMeetingBackgrounds(response);
  } catch (error) {
    console.log(error);
  }
};

export function getJitsiWhisperService(): JitsiWhisperService {
  if (!jitsiWhisperService) {
    jitsiWhisperService = new JitsiWhisperService({
      hosts: { domain: '8x8.vc', muc: 'conference.8x8.vc', anonymousdomain: '' },
      serviceUrl: 'wss://8x8.vc/xmpp-websocket',
      clientNode: 'http://jitsi.org/jitsimeet',
      openBridgeChannel: true,
      p2p: { enabled: false },
    });
  }

  return jitsiWhisperService;
}

export function resetJitsiWhisperService(): void {
  jitsiWhisperService = null;
}
